<template>
  <Dialog :open="currentConfirmation !== null" @update:open="handleOpenChange">
    <DialogContent :show-close-button="false">
      <DialogHeader>
        <DialogTitle>{{ currentConfirmation?.options.title ?? t('confirm.title') }}</DialogTitle>
        <DialogDescription>{{ currentConfirmation?.options.message }}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button type="button" variant="outline" @click="resolveConfirmation(false)">
          {{ currentConfirmation?.options.cancelLabel ?? t('confirm.cancel') }}
        </Button>
        <Button
          type="button"
          :variant="currentConfirmation?.options.destructive ? 'destructive' : 'default'"
          @click="resolveConfirmation(true)"
        >
          {{ currentConfirmation?.options.confirmLabel ?? t('confirm.confirm') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { currentConfirmation, resolveConfirmation } from '@/composables/useConfirm'

const { t } = useI18n()

function handleOpenChange(open: boolean) {
  if (!open) {
    resolveConfirmation(false)
  }
}
</script>
